
import type { Params, SolidGaugeSemicircleChartConfig } from '@empathyco/insights'
import type { PropType } from 'vue'
import type { ColorEnum, KpiEnum } from '../enums'
import { SolidGaugeSemicircleChartComponent } from '@empathyco/insights'

import { defineComponent } from 'vue'

import { UiTooltip } from './keen-ui'

export default defineComponent({
  name: 'GaugeSemicircleChart',
  components: {
    UiTooltip,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    color: {
      type: String as PropType<ColorEnum | KpiEnum>,
      required: true,
    },
    tooltip: String,
  },
  data() {
    return {
      baseClass: 'epb-gauge-semicircle-chart',
      chart: undefined,
    }
  },
  computed: {
    chartParams(): Params<SolidGaugeSemicircleChartConfig, number> {
      return {
        config: {
          locale: this.$epb.locale,
          coreRadius: 40,
        },
        data: this.value,
      }
    },
  },
  watch: {
    chartParams: {
      handler(params: Params<SolidGaugeSemicircleChartConfig, number>): void {
        this.chart.update(params)
      },
      deep: true,
    },
  },
  created(): void {
    this.chart = new SolidGaugeSemicircleChartComponent()
  },
  mounted(): void {
    this.chart.init(this.$refs.chart, this.chartParams)
  },
  beforeDestroy(): void {
    this.chart.destroy()
  },
})
